'use client'

import React from 'react'
import './Button.css'
import './ButtonGroup.css'

export interface ButtonGroupProps {
  children: React.ReactNode
  className?: string
  attached?: boolean
}

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  children,
  className = '',
  attached = false
}) => {
  const classes = [
    'ui-btn-group',
    attached && 'ui-btn-group--attached',
    className
  ].filter(Boolean).join(' ')

  return (
    <div className={classes} role="group">
      {children}
    </div>
  )
}

export default ButtonGroup
